<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-3">
              <router-link
                v-bind:to="'/aliado/info_secundaria/' + id_aliado"
                class="btn btn-orange rounded-pill"
              >
                <i class="bx bx-chevron-left"></i> Regresar
              </router-link>

              <br />
            </div>
            <div class="mt-2 mb-3">
              <h3 class="text-orange fw-bold">{{ aliado.nombre_aliado }}</h3>
            </div>
            <div class="card">
              <div class="card-header">
                <h4 class="text-orange fw-bold">Contrato</h4>
              </div>
              <div class="card-body">
                <div v-if="aliado.firma_contrato == 1">
                  <div class="mb-1 mt-1">
                    Firmado:
                    <h4
                      v-if="aliado.firma_contrato == 1"
                      class="text-orange fw-bold"
                    >
                      Sí
                    </h4>
                    <h4 v-else class="text-orange text-orange fw-bold">No</h4>
                  </div>
                  <div class="mb-1 mt-1">
                    Tipo de firma:
                    <h4
                      v-if="aliado.tipo_firma == 1"
                      class="text-orange fw-bold"
                    >
                      Electrónica
                    </h4>

                    <h4
                      v-if="aliado.tipo_firma == 3"
                      class="text-warning text-orange fw-bold"
                    >
                      Manual
                    </h4>
                    <h4
                      v-if="aliado.tipo_firma == 0"
                      class="text-orange text-orange fw-bold"
                    >
                      -
                    </h4>
                  </div>
                  <div class="mb-3 mt-1">
                    Fecha de firma:
                    <h4 class="text-orange fw-bold">
                      {{ aliado.fecha_firma }}
                    </h4>
                  </div>
                </div>
                <div v-else>
                  <div v-if="aliado.tipo_firma == 2" class="mb-4">
                    <div class="alert alert-warning">
                      <i class="bx bx-info-circle"></i> El contrato fue firmado
                      manualmente y está pendiente de aprobación.
                    </div>
                    <a
                      class="btn btn-outline-primary rounded-pill"
                      v-bind:href="aliado.contrato_fisico"
                      target="_blank"
                    >
                      <i class="bx bx-download"></i> Descargar contrato</a
                    >
                    <button
                      v-on:click="aprobar_firma_manual"
                      class="btn btn-orange ms-1 rounded-pill"
                      v-if="
                        session.usuario.perfil == 0 && aliado.tipo_firma == 2
                      "
                    >
                      <i class="bx bx-check-circle"></i> Aprobar firma manual
                    </button>
                    <hr />
                  </div>
                  <div class="text-info mb-4">
                    <i class="bx bx-info-circle"></i> Utiliza una de las
                    siguientes opciones para la firma del contrato por parte del
                    aliado.
                  </div>
                  <div class="card card-body border">
                    <span class="fw-bold text-info">Firma electrónica</span>
                    <div class="form-group mt-4">
                      <label>Copia enlace para compartir con el aliado</label>
                      <input
                        v-model="aliado.url_contrato"
                        ref="input_enlace_contrato"
                        class="form-control"
                        readonly
                      />
                      <div class="text-center mt-1">
                        <button
                          v-on:click="copiar_enlace_contrato"
                          class="btn btn-outline-secondary rounded-pill"
                        >
                          <i class="bx bx-copy-alt"></i> Copiar
                        </button>
                      </div>
                    </div>
                    <div class="text-center">- ó -</div>
                    <div class="text-center mt-3">
                      <button
                        v-on:click="send_mail_contrato"
                        class="btn btn-orange btn-lg rounded-pill"
                      >
                        <i class="bx bx-envelope"></i> Enviar correo al aliado
                      </button>
                    </div>
                  </div>
                  <div class="card card-body border">
                    <span class="fw-bold text-info">Firma manual</span>
                    <div class="text-center mt-4">
                      <button
                        v-on:click="generar_contrato"
                        class="btn btn-orange btn-lg rounded-pill"
                      >
                        <i class="bx bx-download"></i> Descargar contrato
                      </button>
                    </div>
                  </div>
                </div>

                <div class="text-end">
                  <router-link
                    to="/"
                    class="btn btn-orange btn-lg rounded-pill ms-1"
                  >
                    <i class="bx bx-chevron-left"></i>
                    Finalizar
                  </router-link>
                  <router-link
                    v-bind:to="'/aliado/anexos/' + id_aliado"
                    class="btn btn-success btn-lg rounded-pill ms-1"
                  >
                    Anexos
                    <i class="bx bx-chevron-right"></i>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <router-link
                v-bind:to="'/aliado/info_secundaria/' + id_aliado"
                class="btn btn-orange rounded-pill"
              >
                <i class="bx bx-chevron-left"></i> Regresar
              </router-link>

              <br />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Contrato",
  metaInfo: {
    title: "Contrato - Reddy Backoffice",
  },
  data() {
    return {
      loading: true,
      id_aliado: null,
      aliado: [],
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_aliado = this.$route.params.id_aliado;
    this.get_aliado();
  },
  methods: {
    get_aliado: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "aliados/aliado/" + this.id_aliado, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.aliado = response.data.data;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    aprobar_firma_manual: function () {
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_aliado: this.id_aliado,
      };
      axios
        .post(this.$base_url + "aliados/aprobar_firma", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Contrato firmado",
              text: response.data.message,
            });
            vm.get_aliado();
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    send_mail_contrato: function () {
      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_aliado: this.id_aliado,
      };
      axios
        .post(this.$base_url + "aliados/set_mail_contrato", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
            return false;
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Correo enviado",
              text: response.data.message,
            });
          }
          vm.get_aliado();
          vm.loading = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    generar_contrato: function () {
      window.open(
        this.$base_url + "download/contrato/" + this.id_aliado,
        "_blank"
      );
    },
    copiar_enlace_contrato: function () {
      var content = this.$refs.input_enlace_contrato;
      content.select();
      document.execCommand("copy");
    },
  },
};
</script>